<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
    Header(:content="headerContent")
    div.wrap-trainer-home.f.fh
      ModuleTrainerHome(v-if="trainer" :trainer="trainer")

</template>

<style lang="scss" scoped>
.wrap-trainer-home {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/auth'
import Header from '@/components/shared/Header.vue'
import ModuleTrainerHome from '@/components/module/ModuleTrainerHome'
import { database } from '@shared/database'

export default {
  components: {
    Auth,
    Header,
    ModuleTrainerHome
  },
  data () {
    return {
      trainer: null,
      headerContent: {
        label: '',
        leftAction: {
          icon: 'playlist_add_check',
          color: '#fff',
          method: this.onHeaderLeft
        },
        rightAction: {
          icon: 'home',
          color: '#fff',
          method: this.onHeaderRight
        }
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  // async created () {
  //   this.trainer = await db.collection('TRAINERS')
  //     .where("authedUid", "==", this.uid)
  //     .get()
  //     .then(q => { return q.docs[0].data() })
  //   this.headerContent.label = this.trainer.name
  // },
  methods: {
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async onLoggedIn () {
      // this.trainer = await db.collection('TRAINERS')
      //   .where("authedUid", "==", this.uid)
      //   .get()
      //   .then(q => { return q.docs[0].data() })
      this.trainer = await database.getTrainerByUid(this.uid)
      this.headerContent.label = this.trainer.name
    },
    onHeaderLeft () {
      this.$router.push(`/trainer/report_list`)
    },
    onHeaderRight () {
      this.$router.push(`/trainer/home`)
    }
  }
}
</script>
